import posthog from 'posthog-js'

const KEY = import.meta.env.VITE_POSTHOG_KEY

// ── Environment detection ──────────────────────────────────────────────────────
// Priority: explicit VITE_APP_ENV override → Vite mode flag → hostname heuristic.
// This value is registered as a super property so it appears on every PostHog event.
function detectEnvironment() {
  const explicit = import.meta.env.VITE_APP_ENV
  if (explicit) return String(explicit)

  if (import.meta.env.DEV) return 'Local'

  const host = (typeof window !== 'undefined' ? window.location.hostname : '') || ''
  if (host === 'onceupona.stream' || host.endsWith('.onceupona.stream')) return 'Production'
  if (host.includes('staging') || host.includes('replit')) return 'Staging'
  return 'Production'
}

const ENV     = detectEnvironment()
const IS_PROD = ENV === 'Production'

let ready = false

export function initAnalytics() {
  if (!KEY) {
    if (!IS_PROD) console.warn('[analytics] VITE_POSTHOG_KEY not set — tracking disabled')
    return
  }

  posthog.init(KEY, {
    api_host:          'https://a.onceupona.stream',
    ui_host:           'https://us.posthog.com',
    defaults:          '2026-05-30',
    person_profiles:   'identified_only',
    capture_pageview:  true,
    capture_pageleave: true,
    autocapture:       false,       // disabled in all envs — DOM event noise is not useful
    debug:             !IS_PROD,    // verbose console output only in Local / Staging

    loaded: (ph) => {
      // Register environment as a super property so every subsequent event carries it.
      // Using register() (not register_once()) so that environment changes on deploy
      // are always reflected correctly.
      ph.register({ environment: ENV })
    },
  })

  ready = true
}

export function track(event, properties = {}) {
  if (!ready) {
    if (!IS_PROD) console.log('[PostHog Stub]:', event, properties)
    return
  }
  posthog.capture(event, properties)
}
